import {Component, OnDestroy, OnInit} from '@angular/core';
import {ReplaySubject} from 'rxjs';
import {CommissionRedirection} from '../../../../shared/interface/commission-redirection';
import {UserPermissions} from '../../../../shared/interface/user-permissions';
import {ActivatedRoute, Router} from '@angular/router';
import {CommissionRedirectionService} from '../../../../shared/services/commission-redirection.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {MatDialog} from '@angular/material/dialog';
import {AuthService} from '../../../../shared/services/auth.service';
import {takeUntil} from 'rxjs/operators';
import {HttpErrorResponse} from '@angular/common/http';
import {CommissionSettlement} from '../../../../shared/interface/commission-settlement';
import {CommissionSettlementService} from '../../../../shared/services/commission-settlement.service';

@Component({
  selector: 'app-settlement-details',
  templateUrl: './settlement-details.component.html',
  styleUrls: ['./settlement-details.component.scss']
})
export class SettlementDetailsComponent implements OnInit, OnDestroy {
  commissionSettlementId?: string = null;
  commissionSettlement: ReplaySubject<CommissionSettlement> = new ReplaySubject(1);
  commissionSettlementObject?: CommissionSettlement = null;
  modify = false;
  userPermissions: ReplaySubject<UserPermissions>;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private commissionSettlementService: CommissionSettlementService,
    private snack: MatSnackBar,
    private dialog: MatDialog,
    private auth: AuthService,
  ) {
    this.userPermissions = auth.getUserPermissions();
  }

  ngOnInit(): void {
    this.route.params
      .pipe(takeUntil(this.destroyed$))
      .subscribe(params => {
        this.commissionSettlementId = params.id;
        this.loadCommissionSettlement();
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  loadCommissionSettlement(): void {
    this.commissionSettlementService.get(this.commissionSettlementId).subscribe((commissionSettlement: CommissionSettlement) => {
      this.commissionSettlement.next(commissionSettlement);
      this.commissionSettlementObject = commissionSettlement;
    }, (error: HttpErrorResponse) => {
      this.snack.open('Nie udało się pobrać danych rozliczenia', error.status.toString(), {
        duration: 2000
      });

      this.router.navigate(['/rozliczenia']);
    });
  }

}
